import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
export default function Filter(_a) {
    var _b, _c;
    var options = _a.options, handleChange = _a.handleChange, currentValue = _a.currentValue;
    var _d = useState(((_b = options[0]) === null || _b === void 0 ? void 0 : _b.label) || ''), selectedLabel = _d[0], setSelectedLabel = _d[1];
    var _e = useState(((_c = options[0]) === null || _c === void 0 ? void 0 : _c.value) || ''), selectedValue = _e[0], setSelectedValue = _e[1];
    var mainRef = useRef(null);
    var fieldName = useMemo(function () { return (Math.random() + 1).toString(36); }, []);
    var handleClick = useCallback(function (event) {
        if (event.target instanceof HTMLElement && mainRef.current && !mainRef.current.contains(event.target)) {
            close();
        }
    }, []);
    useEffect(function () {
        var selectedLabelInOptions = options.filter(function (fo) { return fo.label === selectedLabel; })[0];
        if (!selectedLabelInOptions) {
            var selectedOption = options.filter(function (fo) { return fo.value === selectedValue; })[0];
            setSelectedLabel((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || '');
        }
    }, [options, selectedLabel, selectedValue]);
    useEffect(function () {
        document.addEventListener('click', handleClick, true);
        return function () {
            document.removeEventListener('click', handleClick, true);
        };
    }, [handleClick]);
    useEffect(function () {
        var _a, _b;
        var isFirstOption = ((_a = options[0]) === null || _a === void 0 ? void 0 : _a.label) === selectedLabel;
        var shouldNotBeFirstOption = isFirstOption && currentValue && ((_b = options[0]) === null || _b === void 0 ? void 0 : _b.value) !== currentValue;
        if (isFirstOption && shouldNotBeFirstOption) {
            var currentOption = options.filter(function (fo) { return fo.value === currentValue; })[0];
            if (currentOption) {
                setSelectedLabel(currentOption.label);
                handleChange(currentOption.value);
            }
        }
    }, [currentValue, selectedLabel, handleChange, options]);
    useEffect(function () {
        var _a;
        var currentValueNotValid = currentValue && options.filter(function (fo) { return fo.value === currentValue; }).length === 0;
        if (currentValueNotValid) {
            handleChange((_a = options[0]) === null || _a === void 0 ? void 0 : _a.value);
        }
    }, [currentValue, handleChange, options]);
    var close = function () {
        var _a;
        if ((_a = mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) === null || _a === void 0 ? void 0 : _a.checked) {
            mainRef.current.checked = false;
        }
    };
    var handleSelect = function (event) {
        var _a;
        var label = (event === null || event === void 0 ? void 0 : event.target.getAttribute('data-name')) || '';
        var value = ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) || '';
        setSelectedLabel(label);
        setSelectedValue(value);
        handleChange(value);
        close();
    };
    return (React.createElement("div", { className: "filter-select" },
        React.createElement("input", { type: "checkbox", className: "filter-select-input", ref: mainRef }),
        React.createElement("div", { className: "filter-select-button" },
            React.createElement("div", { className: "filter-select-value" },
                React.createElement("span", null, selectedLabel)),
            React.createElement("div", { className: "filter-select-toggle" },
                React.createElement("div", null),
                React.createElement("div", null))),
        React.createElement("div", { className: "filter-select-options" }, options.map(function (fo, i) { return (React.createElement("div", { className: fo.disabled ? 'disabled filter-select-option' : 'filter-select-option', key: i },
            fo.disabled !== true && (React.createElement("input", { type: "radio", name: fieldName, value: fo.value, "data-name": fo.label, onClick: handleSelect })),
            React.createElement("span", { className: "filter-select-option-label" }, fo.label))); }))));
}
